export class CreateIntegrationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integration",
            "baseName": "integration",
            "type": "IntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateIntegrationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
